<template>
  <v-card class="mx-auto" max-width="2000">
    <v-card-actions
      class="p-0"
      style="cursor: pointer; background-color: #ffca00"
      @click="show = !show"
    >
      <h4 class="px-3 mt-2">Painel de Desempenho — Técnicos</h4>
    </v-card-actions>
    <v-expand-transition>
      <div v-if="show">
        <v-card-text class="p-0 mt-2">
          <div id="container-painel-tecnicos" class="vs-con-loading__container">
            <div v-if="active" class="pt-report">
              <!-- KPIs -->
              <section class="kpis">
                <div class="kpi" v-for="(k, i) in kpis" :key="i" :class="{ accent: k.accent }">
                  <span class="lbl">{{ k.lbl }}</span>
                  <span class="val">{{ k.val }}</span>
                  <span class="foot">{{ k.foot }}</span>
                </div>
              </section>

              <!-- Alertas + Distribuição -->
              <section class="mid">
                <div class="card">
                  <h2>Alertas &amp; qualidade de dado <span class="n">{{ alerts.length }}</span></h2>
                  <div v-if="!alerts.length" class="empty">Nenhum alerta no período.</div>
                  <div class="alert" v-for="(a, i) in alerts" :key="i">
                    <span class="tag" :class="a.tag">{{ a.tag === 'c' ? '!' : a.tag === 'w' ? '▲' : '·' }}</span>
                    <span class="txt"><b>{{ a.lead }}</b> {{ a.body }}</span>
                  </div>
                </div>
                <div class="card">
                  <h2>Distribuição por faixa (horas)</h2>
                  <div class="distbar">
                    <span
                      v-for="b in distBars"
                      :key="b.k"
                      :style="{ flex: b.v, background: b.c }"
                      :title="`${b.v} técnico(s)`"
                    >{{ b.v }}</span>
                  </div>
                  <div class="legend">
                    <span><i style="background:var(--pt-crit)"></i>Crítico &lt;75%</span>
                    <span><i style="background:var(--pt-warn)"></i>Atenção 75–85%</span>
                    <span><i style="background:var(--pt-good)"></i>Bom 85–95%</span>
                    <span><i style="background:var(--pt-exc)"></i>Ótimo ≥95%</span>
                  </div>
                  <h2 style="margin-top:18px">Top 10 — Premiação (R$)</h2>
                  <div>
                    <div class="topbar-row" v-for="d in top10Premiacao" :key="d.id">
                      <span class="nm" :title="d.n">{{ d.n }}</span>
                      <span class="track"><span class="fill" :style="{ width: d.widthPct + '%' }"></span></span>
                      <span class="v">R$ {{ fmtBR(d.p) }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Controles -->
              <div class="controls">
                <div class="search">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
                  <input v-model="query" type="text" placeholder="Buscar técnico…" autocomplete="off">
                </div>
                <div class="filters">
                  <button
                    v-for="f in filterOptions"
                    :key="f.key"
                    :class="{ on: filterMode === f.key }"
                    @click="filterMode = f.key"
                  >{{ f.label }}</button>
                </div>
              </div>

              <!-- Tabela -->
              <div class="tablecard">
                <div class="tscroll">
                  <table>
                    <thead>
                      <tr>
                        <th class="rank">#</th>
                        <th @click="toggleSort('n')" :class="{ sorted: sortK === 'n' }">Técnico <span class="arw">▲▼</span></th>
                        <th class="num" @click="toggleSort('hp')" :class="{ sorted: sortK === 'hp' }">Exec. horas <span class="arw">▲▼</span></th>
                        <th class="barcell">Taxa (horas) · meta 85%</th>
                        <th class="num" @click="toggleSort('sp')" :class="{ sorted: sortK === 'sp' }">Exec. serviços <span class="arw">▲▼</span></th>
                        <th class="num" @click="toggleSort('ne')" :class="{ sorted: sortK === 'ne' }">Não exec. <span class="arw">▲▼</span></th>
                        <th class="num" @click="toggleSort('p')" :class="{ sorted: sortK === 'p' }">Premiação <span class="arw">▲▼</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in sortedRows" :key="d.id" :class="{ inact: !d.active }">
                        <td class="rank">{{ i + 1 }}</td>
                        <td class="name">
                          <span class="dot" :style="{ background: tier(d.hp).c }"></span>{{ d.n }}
                          <span class="flags">
                            <span v-if="d.dup" class="chip dup">dup</span>
                            <span v-if="d.zero" class="chip zero">0h</span>
                            <span v-if="d.lacuna" class="chip gap">lacuna {{ Math.round(d.gap) }}pp</span>
                          </span>
                        </td>
                        <td class="num">{{ pct(d.hp) }}</td>
                        <td class="barcell">
                          <span v-if="d.hp == null" class="barlabel">sem produção</span>
                          <template v-else>
                            <div class="bar">
                              <span class="fill" :style="{ width: Math.min(d.hp, 100) + '%', background: tier(d.hp).c }"></span>
                              <span class="tgt" style="left:85%"></span>
                            </div>
                            <div class="barlabel">{{ pct(d.hp) }} · {{ fmtH(d.he) }}/{{ fmtH(d.ht) }}h</div>
                          </template>
                        </td>
                        <td class="num">
                          {{ pct(d.sp) }}<br>
                          <span class="sub">{{ d.st > 0 ? d.se + '/' + d.st : '—' }}</span>
                        </td>
                        <td class="num">{{ d.ne }}</td>
                        <td class="num">R$ {{ fmtBR(d.p) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td class="lbl">{{ footer.count }} linha(s) · {{ footer.activeCount }} ativo(s)</td>
                        <td class="num">{{ footer.ht > 0 ? pct(footer.hpPct) : '—' }}</td>
                        <td class="barcell sub">{{ fmtH(footer.he) }}/{{ fmtH(footer.ht) }}h</td>
                        <td class="num">{{ footer.st > 0 ? pct(footer.spPct) : '—' }}</td>
                        <td class="num">{{ footer.ne }}</td>
                        <td class="num">R$ {{ fmtBR(footer.p) }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <footer class="note">
                <b>Legenda de faixas</b> por taxa de execução de <b>horas</b> (peso operacional real, não contagem de serviços).
                O chip <span class="chip gap">lacuna</span> marca técnicos cuja taxa de <i>serviços</i> supera a de <i>horas</i> em ≥10 pontos —
                indício de que fecham serviços curtos mas deixam os longos/pesados sem executar.
                <span class="chip dup">dup</span> = nome duplicado no cadastro &nbsp;·&nbsp;
                <span class="chip zero">0h</span> = serviços com horas totais zeradas.
                Inativos (0 serviços no período) ficam fora dos totais de taxa.
              </footer>
            </div>
            <div v-else>
              <vs-row vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
                <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
                  <p class="mt-10 pt-10" style="font-size: 30px; height: 320px">Carregando... {{ loading }}%</p>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  props: {
    show: Boolean,
    filtro: Object
  },
  data() {
    return {
      data: [],
      active: false,
      loading: 0,
      query: "",
      filterMode: "ativos",
      sortK: "hp",
      sortDir: 1,
      filterOptions: [
        { key: "ativos", label: "Ativos" },
        { key: "todos", label: "Todos" },
        { key: "criticos", label: "Críticos" },
        { key: "lacuna", label: "Com lacuna" },
        { key: "inativos", label: "Inativos" }
      ]
    };
  },
  computed: {
    activeTecnicos() {
      return this.data.filter(d => d.active);
    },
    inativosList() {
      return this.data.filter(d => !d.active);
    },
    horasExecTotal() {
      return this.activeTecnicos.reduce((a, d) => a + (d.he || 0), 0);
    },
    horasTotalTotal() {
      return this.activeTecnicos.reduce((a, d) => a + (d.ht || 0), 0);
    },
    taxaHoras() {
      return this.horasTotalTotal > 0 ? (this.horasExecTotal / this.horasTotalTotal) * 100 : null;
    },
    criticosCount() {
      return this.activeTecnicos.filter(d => d.hp != null && d.hp < 75).length;
    },
    comLacuna() {
      return this.activeTecnicos.filter(d => d.lacuna).sort((a, b) => b.gap - a.gap);
    },
    kpis() {
      const totPrem = this.data.reduce((a, d) => a + d.p, 0);
      const totNE = this.data.reduce((a, d) => a + d.ne, 0);
      return [
        {
          lbl: "Taxa exec. (horas)",
          val: this.pct(this.taxaHoras),
          foot: `${this.fmtH(this.horasExecTotal)}h de ${this.fmtH(this.horasTotalTotal)}h`,
          accent: true
        },
        {
          lbl: "Horas não executadas",
          val: `${this.fmtH(this.horasTotalTotal - this.horasExecTotal)}h`,
          foot: "trabalho planejado perdido"
        },
        {
          lbl: "Serviços não exec.",
          val: totNE.toLocaleString("pt-BR"),
          foot: "soma de OS não realizadas"
        },
        {
          lbl: "Premiação total",
          val: `R$ ${this.fmtBR(totPrem)}`,
          foot: "pago no período"
        },
        {
          lbl: "Técnicos ativos",
          val: `${this.activeTecnicos.length}`,
          foot: `${this.inativosList.length} inativos no período`
        },
        {
          lbl: "Em faixa crítica",
          val: `${this.criticosCount}`,
          foot: "abaixo de 75% em horas"
        }
      ];
    },
    alerts() {
      const items = [];

      const dupNames = [...new Set(this.data.filter(d => d.dup).map(d => d.n))];
      if (dupNames.length) {
        items.push({
          tag: "c",
          lead: "Cadastro duplicado.",
          body: `${dupNames.join(", ")} — nome aparece mais de uma vez no cadastro de técnicos. Consolidar matrícula.`
        });
      }

      const zeros = this.data.filter(d => d.zero);
      if (zeros.length) {
        items.push({
          tag: "c",
          lead: "Serviços sem horas lançadas.",
          body: `${zeros.map(d => d.n).join(", ")}: serviços registrados sem apontamento de horas.`
        });
      }

      const comNaoExec = this.activeTecnicos.filter(d => d.ne > 0);
      if (comNaoExec.length) {
        const bigNE = [...comNaoExec].sort((a, b) => b.ne - a.ne)[0];
        items.push({
          tag: "c",
          lead: "Mais serviços não executados.",
          body: `${bigNE.n} lidera em não executados (${bigNE.ne}), com taxa de horas de ${this.pct(bigNE.hp)}.`
        });
      }

      const worst = [...this.activeTecnicos]
        .filter(d => d.hp != null)
        .sort((a, b) => a.hp - b.hp)
        .slice(0, 3);
      if (worst.length) {
        items.push({
          tag: "w",
          lead: "Menores taxas de horas:",
          body: worst.map(d => `${d.n} (${this.pct(d.hp)})`).join(", ")
        });
      }

      const lac = this.comLacuna;
      if (lac.length) {
        items.push({
          tag: "w",
          lead: "Lacuna serviços × horas.",
          body: `${lac.length} técnico(s) fecham muitos serviços curtos mas deixam os longos sem executar: destaque para ${lac[0].n} (serviços ${this.pct(lac[0].sp)} vs horas ${this.pct(lac[0].hp)}).`
        });
      }

      if (this.inativosList.length) {
        items.push({
          tag: "i",
          lead: `${this.inativosList.length} técnico(s) sem produção`,
          body: "no período (0 serviços). Se algum deveria ter apontamento, é furo de lançamento."
        });
      }

      return items;
    },
    distBars() {
      const buckets = { crit: 0, warn: 0, good: 0, exc: 0 };
      this.activeTecnicos.forEach(d => {
        if (d.hp == null) return;
        buckets[this.tier(d.hp).k]++;
      });
      const map = [
        ["crit", "var(--pt-crit)"],
        ["warn", "var(--pt-warn)"],
        ["good", "var(--pt-good)"],
        ["exc", "var(--pt-exc)"]
      ];
      return map.filter(([k]) => buckets[k] > 0).map(([k, c]) => ({ k, c, v: buckets[k] }));
    },
    top10Premiacao() {
      const top = [...this.data].sort((a, b) => b.p - a.p).slice(0, 10);
      const max = top.length && top[0].p > 0 ? top[0].p : 1;
      return top.map(d => ({ ...d, widthPct: (d.p / max) * 100 }));
    },
    filteredRows() {
      const q = this.query.trim().toLowerCase();
      return this.data.filter(d => {
        if (q && !d.n.toLowerCase().includes(q)) return false;
        switch (this.filterMode) {
          case "todos":
            return true;
          case "ativos":
            return d.active;
          case "inativos":
            return !d.active;
          case "criticos":
            return d.active && d.hp != null && d.hp < 75;
          case "lacuna":
            return d.lacuna;
          default:
            return true;
        }
      });
    },
    sortedRows() {
      const rows = [...this.filteredRows];
      const dir = this.sortDir;
      if (this.sortK === "n") {
        rows.sort((a, b) => a.n.localeCompare(b.n, "pt-BR") * dir);
      } else {
        const map = { hp: d => (d.hp == null ? -1 : d.hp), sp: d => (d.sp == null ? -1 : d.sp), ne: d => d.ne, p: d => d.p };
        const f = map[this.sortK] || map.hp;
        rows.sort((a, b) => (f(a) - f(b)) * dir);
      }
      return rows;
    },
    footer() {
      const rows = this.sortedRows;
      const vis = rows.filter(d => d.active);
      const he = vis.reduce((a, d) => a + (d.he || 0), 0);
      const ht = vis.reduce((a, d) => a + (d.ht || 0), 0);
      const se = vis.reduce((a, d) => a + d.se, 0);
      const st = vis.reduce((a, d) => a + d.st, 0);
      const ne = vis.reduce((a, d) => a + d.ne, 0);
      const p = rows.reduce((a, d) => a + d.p, 0);
      return {
        count: rows.length,
        activeCount: vis.length,
        he,
        ht,
        se,
        st,
        ne,
        p,
        hpPct: ht > 0 ? (he / ht) * 100 : null,
        spPct: st > 0 ? (se / st) * 100 : null
      };
    }
  },
  methods: {
    async prepareDashboard() {
      await this.$vs.loading({
        container: "#container-painel-tecnicos",
        type: "sound",
        scale: 0.6
      });
      this.loading += await 30;
      await this.getTecnicosCard();
      this.loading += await 30;
      this.active = true;
      await this.$vs.loading.close("#container-painel-tecnicos > .con-vs-loading");
    },
    async getTecnicosCard() {
      try {
        this.loading += await 20;
        const result = await this.$http.post("getTecnicosCard", this.filtro);
        this.data = this.processarTecnicos(result || []);
        this.loading += await 20;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    processarTecnicos(result) {
      const nameCounts = {};
      result.forEach(t => {
        nameCounts[t.nome] = (nameCounts[t.nome] || 0) + 1;
      });
      return result.map(t => {
        const totais = t.totais || {};
        const st = totais.total_servicos_exec || 0;
        const se = totais.servicos_exec || 0;
        const he = totais.horas_exec;
        const ht = totais.total_horas_exec;
        const active = st > 0;
        const sp = active ? (se / st) * 100 : null;
        const hp = ht != null && ht > 0 ? (he / ht) * 100 : null;
        const gap = sp != null && hp != null ? sp - hp : null;
        return {
          id: t.id,
          n: t.nome,
          p: t.comissao || 0,
          se,
          st,
          he,
          ht,
          ne: st - se,
          active,
          sp,
          hp,
          gap,
          dup: nameCounts[t.nome] > 1,
          zero: active && ht === 0,
          lacuna: gap != null && gap >= 10 && active
        };
      });
    },
    toggleSort(key) {
      if (this.sortK === key) {
        this.sortDir *= -1;
      } else {
        this.sortK = key;
        this.sortDir = key === "n" ? 1 : -1;
      }
    },
    tier(hp) {
      if (hp == null) return { k: "inact", c: "var(--pt-inact)" };
      if (hp < 75) return { k: "crit", c: "var(--pt-crit)" };
      if (hp < 85) return { k: "warn", c: "var(--pt-warn)" };
      if (hp < 95) return { k: "good", c: "var(--pt-good)" };
      return { k: "exc", c: "var(--pt-exc)" };
    },
    fmtBR(v) {
      return Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    fmtH(v) {
      return v == null ? "—" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
    pct(v) {
      return v == null ? "—" : v.toFixed(1).replace(".", ",") + "%";
    }
  },
  async mounted() {
    await this.prepareDashboard();
  },
  components: {
    ...components
  }
};
</script>

<style scoped lang="scss">
.pt-report {
  --pt-bg: #eef1ee;
  --pt-panel: #ffffff;
  --pt-ink: #16231f;
  --pt-ink-soft: #4b5c56;
  --pt-line: #dde3df;
  --pt-brand: #0f6e5c;
  --pt-brand-deep: #0a4a3e;
  --pt-crit: #c0392b;
  --pt-warn: #c9820a;
  --pt-good: #2e9e6b;
  --pt-exc: #0f6e5c;
  --pt-inact: #9aa7a2;
  padding: 16px;
  color: var(--pt-ink);
  font-size: 15px;
  line-height: 1.45;

  .kpis {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
    margin-bottom: 16px;
  }
  .kpi {
    background: var(--pt-panel);
    border: 1px solid var(--pt-line);
    border-radius: 12px;
    padding: 14px 15px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .kpi .lbl {
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--pt-ink-soft);
    font-weight: 600;
  }
  .kpi .val {
    font-family: "SF Mono", ui-monospace, "Roboto Mono", Menlo, Consolas, monospace;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -0.01em;
  }
  .kpi .foot {
    font-size: 11.5px;
    color: var(--pt-ink-soft);
  }
  .kpi.accent {
    background: linear-gradient(160deg, var(--pt-brand), var(--pt-brand-deep));
    border-color: var(--pt-brand-deep);
  }
  .kpi.accent .lbl,
  .kpi.accent .foot {
    color: #cbe7df;
  }
  .kpi.accent .val {
    color: #fff;
  }

  .mid {
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  .card {
    background: var(--pt-panel);
    border: 1px solid var(--pt-line);
    border-radius: 12px;
    padding: 16px 18px;
  }
  .card h2 {
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 0 0 14px;
    color: var(--pt-brand-deep);
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .card h2 .n {
    font-family: monospace;
    background: var(--pt-bg);
    border: 1px solid var(--pt-line);
    border-radius: 20px;
    padding: 1px 9px;
    font-size: 11px;
    color: var(--pt-ink-soft);
    font-weight: 600;
  }
  .card .empty {
    color: var(--pt-ink-soft);
    font-size: 13px;
  }

  .alert {
    display: flex;
    gap: 11px;
    padding: 10px 0;
    border-top: 1px solid var(--pt-line);
  }
  .alert:first-of-type {
    border-top: none;
  }
  .alert .tag {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    display: grid;
    place-items: center;
    font-size: 12px;
    font-weight: 800;
    color: #fff;
    margin-top: 1px;
  }
  .alert .tag.c {
    background: var(--pt-crit);
  }
  .alert .tag.w {
    background: var(--pt-warn);
  }
  .alert .tag.i {
    background: var(--pt-inact);
  }
  .alert .txt {
    font-size: 13px;
  }

  .distbar {
    display: flex;
    height: 34px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid var(--pt-line);
    margin-bottom: 12px;
  }
  .distbar span {
    display: grid;
    place-items: center;
    color: #fff;
    font-family: monospace;
    font-size: 12px;
    font-weight: 600;
    min-width: 0;
  }
  .legend {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12px;
    color: var(--pt-ink-soft);
  }
  .legend i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 3px;
    margin-right: 5px;
    vertical-align: -1px;
  }

  .topbar-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 7px;
    font-size: 12.5px;
  }
  .topbar-row .nm {
    flex: 0 0 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .topbar-row .track {
    flex: 1;
    background: var(--pt-bg);
    border-radius: 5px;
    height: 14px;
    position: relative;
    overflow: hidden;
  }
  .topbar-row .fill {
    position: absolute;
    inset: 0 auto 0 0;
    background: linear-gradient(90deg, var(--pt-brand), var(--pt-brand-deep));
    border-radius: 5px;
  }
  .topbar-row .v {
    flex: 0 0 78px;
    text-align: right;
    font-family: monospace;
    font-size: 12px;
  }

  .controls {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin-bottom: 12px;
  }
  .search {
    flex: 1;
    min-width: 200px;
    position: relative;
  }
  .search input {
    width: 100%;
    padding: 9px 12px 9px 34px;
    border: 1px solid var(--pt-line);
    border-radius: 9px;
    font-size: 14px;
    background: var(--pt-panel);
    color: var(--pt-ink);
  }
  .search input:focus {
    outline: 2px solid var(--pt-brand);
    outline-offset: -1px;
    border-color: var(--pt-brand);
  }
  .search svg {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.5;
  }
  .filters {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }
  .filters button {
    font-size: 13px;
    padding: 8px 13px;
    border: 1px solid var(--pt-line);
    background: var(--pt-panel);
    border-radius: 8px;
    cursor: pointer;
    color: var(--pt-ink-soft);
    font-weight: 500;
    transition: 0.12s;
  }
  .filters button:hover {
    border-color: var(--pt-brand);
  }
  .filters button.on {
    background: var(--pt-brand-deep);
    border-color: var(--pt-brand-deep);
    color: #fff;
  }

  .tablecard {
    background: var(--pt-panel);
    border: 1px solid var(--pt-line);
    border-radius: 12px;
    overflow: hidden;
  }
  .tscroll {
    overflow-x: auto;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13.5px;
  }
  thead th {
    position: sticky;
    top: 0;
    background: var(--pt-brand-deep);
    color: #eaf3f0;
    text-align: left;
    padding: 11px 12px;
    font-size: 11.5px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
  }
  thead th.num {
    text-align: right;
  }
  thead th .arw {
    opacity: 0.4;
    font-size: 10px;
    margin-left: 3px;
  }
  thead th.sorted .arw {
    opacity: 1;
  }
  tbody td {
    padding: 9px 12px;
    border-top: 1px solid var(--pt-line);
    vertical-align: middle;
  }
  tbody tr:hover {
    background: #f6f9f7;
  }
  tbody tr.inact {
    opacity: 0.62;
  }
  td.num {
    text-align: right;
    font-family: monospace;
    font-size: 12.5px;
    white-space: nowrap;
  }
  td .sub {
    color: var(--pt-ink-soft);
    font-size: 11px;
  }
  .rank {
    font-family: monospace;
    color: var(--pt-ink-soft);
    font-size: 12px;
    width: 34px;
  }
  .name {
    font-weight: 600;
    white-space: nowrap;
  }
  .name .flags {
    margin-left: 6px;
  }
  .chip {
    display: inline-block;
    font-family: monospace;
    font-size: 10px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 5px;
    vertical-align: 1px;
    margin-left: 4px;
  }
  .chip.dup {
    background: #f7e4c4;
    color: #8a5a00;
  }
  .chip.zero {
    background: #f3d3cf;
    color: #8a201a;
  }
  .chip.gap {
    background: #fbe5c7;
    color: #996100;
  }
  .dot {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 7px;
    vertical-align: 0;
  }
  .barcell {
    min-width: 150px;
  }
  .bar {
    position: relative;
    background: var(--pt-bg);
    border-radius: 5px;
    height: 16px;
    overflow: hidden;
  }
  .bar .fill {
    position: absolute;
    inset: 0 auto 0 0;
    border-radius: 5px;
  }
  .bar .tgt {
    position: absolute;
    top: -2px;
    bottom: -2px;
    width: 2px;
    background: rgba(0, 0, 0, 0.35);
  }
  .barlabel {
    font-family: monospace;
    font-size: 11.5px;
    margin-top: 2px;
    color: var(--pt-ink-soft);
  }

  tfoot td {
    padding: 11px 12px;
    border-top: 2px solid var(--pt-brand-deep);
    font-family: monospace;
    font-size: 12.5px;
    font-weight: 600;
    background: #f6f9f7;
  }
  tfoot td.lbl {
    font-family: inherit;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 11.5px;
  }

  footer.note {
    margin-top: 16px;
    font-size: 11.5px;
    color: var(--pt-ink-soft);
    line-height: 1.6;
  }

  @media (max-width: 900px) {
    .kpis {
      grid-template-columns: repeat(3, 1fr);
    }
    .mid {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 560px) {
    .kpis {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
